<template>
  <el-tree
    ref="treeRef"
    :data="allNodes"
    show-checkbox
    node-key="id"
    :default-checked-keys="selectedNodes"
    :default-expanded-keys="selectedNodes"
    :check-on-click-node="!readonly"
    :class="{ 'readonly-tree': readonly }"
    @check="handleChange"
  />
</template>
<script lang="ts">
import { onUpdated, ref } from 'vue';

import { ElTree } from 'element-plus';

import TreeNode from '@/components/types/treeNode';

export default {
  name: 'BaseTree',
  components: {
    ElTree
  },
  props: {
    allNodes: {
      type: Array as () => Array<TreeNode>,
      default: new Array<TreeNode>()
    },
    selectedNodes: {
      type: Array as () => Array<number>,
      default: new Array<number>()
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const treeRef = ref<InstanceType<typeof ElTree>>();

    const handleChange = (data: TreeNode, treeState: any) => {
      if (props.readonly) {
        treeRef.value?.setCheckedKeys(props.selectedNodes, false);
        return;
      }
      const checkedValues: string[] = [];
      treeState.checkedNodes.forEach(node => {
        node.values.forEach(value => {
          if (!checkedValues.includes(value)) checkedValues.push(value);
        });
      });
      emit('change', checkedValues);
    };

    onUpdated(() => {
      treeRef.value?.setCheckedKeys(props.selectedNodes, false);
    });

    return {
      handleChange,
      treeRef
    };
  }
};
</script>

<style scoped lang="scss">
:deep(.el-tree-node__label) {
  text-overflow: clip;
  white-space: normal;
  overflow: visible;
}

.readonly-tree :deep(.el-checkbox__input) {
  pointer-events: none;
  cursor: not-allowed;
}

.readonly-tree :deep(.el-checkbox) {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}

.readonly-tree :deep(.el-tree-node__content) {
  cursor: default;
}
</style>
